/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ]
  }
  ```
*/
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment HeroDarkWithIllustrationData on StrapiComponentHeroDarkWithIllustration {
    title
    topic
    description
    signUpText
    signUpPlaceholderText
    signUpButtonText
    privacyPolicyText
    image {
      ...StrapiMediaSubquery
    }
  }
`;

function DarkWithIllustration({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="min-h-screen">
      <div className="relative overflow-hidden">
        <main>
          <div className="bg-background-primary-dark pt-10 sm:pt-16 lg:overflow-hidden lg:pb-14 lg:pt-8">
            <div className="mx-auto max-w-7xl lg:px-8">
              <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:flex lg:items-center lg:px-0 lg:text-left">
                  <div className="lg:py-24">
                    {data.topic && (
                      <h3 className="mt-4 text-2xl tracking-tight text-text-white sm:mt-5 sm:text-3xl lg:mt-6">
                        <span>
                          <MarkdownWrapper text={data.topic} />
                        </span>
                      </h3>
                    )}
                    {data.title && (
                      <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-text-white sm:mt-5 sm:text-6xl lg:mt-6 xl:text-6xl">
                        <span>
                          <MarkdownWrapper text={data.title} />
                        </span>
                      </h1>
                    )}
                    {data.description && (
                      <MarkdownWrapper
                        text={data.description}
                        markdownClassName="mt-3 text-base text-secondary-light sm:mt-5 sm:text-xl lg:text-lg xl:text-xl"
                        replaceParagraph={false}
                      />
                    )}
                    <div className="mt-10 sm:mt-12">
                      <form
                        action="#"
                        className="sm:mx-auto sm:max-w-xl lg:mx-0"
                      >
                        <div className="sm:flex">
                          <div className="min-w-0 flex-1">
                            <input
                              id="email"
                              type="email"
                              placeholder={
                                data.signUpPlaceholderText || "Email"
                              }
                              className="block w-full rounded-md border-0 px-4 py-3 text-base text-text-dark-gray placeholder-placeholder-gray focus:outline-none focus:ring-2 focus:ring-ring-primary-light focus:ring-offset-2 focus:ring-offset-ring-offset-primary-dark"
                            />
                          </div>
                          <div className="mt-3 sm:ml-3 sm:mt-0">
                            <button
                              type="submit"
                              className="block w-full rounded-md bg-background-primary px-4 py-3 font-medium text-text-white shadow hover:bg-background-primary focus:outline-none focus:ring-2 focus:ring-ring-primary-light focus:ring-offset-2 focus:ring-offset-ring-offset-primary-dark"
                            >
                              {data.signUpButtonText || "Submit"}
                            </button>
                          </div>
                        </div>
                        {data.privacyPolicyText && (
                          <MarkdownWrapper
                            text={data.privacyPolicyText}
                            markdownClassName="mt-3 text-sm text-text-secondary-light sm:mt-4"
                            replaceParagraph={false}
                          />
                        )}
                      </form>
                    </div>
                  </div>
                </div>
                {data.image && (
                  <div className="-mb-16 mt-12 sm:-mb-48 lg:relative lg:m-0">
                    <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0">
                      <MediaWrapper
                        media={data.image}
                        divClassName="w-full lg:absolute lg:inset-y-0 lg:left-0 lg:h-full lg:w-auto lg:max-w-none"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

DarkWithIllustration.propTypes = {
  data: PropTypes.object,
};

export default DarkWithIllustration;
